/* global JQuery */
import { Lang } from '../../Lang';
import { FormGroup2, Input2, InputType2, ModalDialog2, ModalDialogType2, Select2 } from 'bambooo';
/**
 * SpeciesEditModal
 */
export class SpeciesEditModal extends ModalDialog2 {
    /**
     * constructor
     */
    constructor() {
        super({ modalType: ModalDialogType2.large });
        /**
         * id of entry
         * @protected
         */
        this._id = null;
        const bodyCard = jQuery('<div class="card-body"/>').appendTo(this.getBody());
        const groupName = new FormGroup2({ label: Lang.i().l('Specie-Name') });
        groupName.appendTo(bodyCard);
        this._inputName = new Input2({});
        this._inputName.appendTo(groupName);
        this._inputName.setPlaceholder(Lang.i().l('Name of specie'));
        const groupOttId = new FormGroup2({ label: Lang.i().l('Ott-Id') });
        groupOttId.appendTo(bodyCard);
        this._ottId = new Input2({ type: InputType2.number });
        this._ottId.appendTo(groupOttId);
        const groupAphiaId = new FormGroup2({ label: Lang.i().l('WoRMS aphia-ID') });
        groupAphiaId.appendTo(bodyCard);
        this._aphiaId = new Input2({ type: InputType2.number });
        this._aphiaId.appendTo(groupAphiaId);
        this._aphiaLink = jQuery('<small class="form-text"><a href="#" target="_blank" rel="noopener noreferrer">Open on marinespecies.org</a></small>')
            .hide()
            .appendTo(groupAphiaId.getElement());
        this._aphiaId.getElement().on('input change', () => {
            this._updateAphiaLink();
        });
        const groupSpeciesGroup = new FormGroup2({ label: Lang.i().l('Specie-Group') });
        groupSpeciesGroup.appendTo(bodyCard);
        this._selectSpeciesGroup = new Select2({});
        this._selectSpeciesGroup.appendTo(groupSpeciesGroup);
        // buttons -----------------------------------------------------------------------------------------------------
        this.addButtonClose(Lang.i().l('Close'));
        this.addButtonSave(Lang.i().l('Save changes'), true);
    }
    /**
     * getId
     */
    getSpecieId() {
        return this._id;
    }
    /**
     * setId
     * @param id
     */
    setSpecieId(id) {
        this._id = id;
    }
    /**
     * getName
     */
    getName() {
        return this._inputName.getValue();
    }
    /**
     * setName
     * @param name
     */
    setName(name) {
        this._inputName.setValue(name);
    }
    /**
     * Set the Ott ID
     * @param {number} id
     */
    setOttId(id) {
        this._ottId.setValue(`${id}`);
    }
    /**
     * Return the Ott ID
     * @returns {number}
     */
    getOttId() {
        return parseInt(this._ottId.getValue(), 10) || 0;
    }
    /**
     * Set the WoRMS aphia ID
     * @param {number} id
     */
    setAphiaId(id) {
        this._aphiaId.setValue(id === 0 ? '' : `${id}`);
        this._updateAphiaLink();
    }
    /**
     * Return the WoRMS aphia ID
     * @returns {number}
     */
    getAphiaId() {
        return parseInt(this._aphiaId.getValue(), 10) || 0;
    }
    /**
     * Show/hide the marinespecies.org link based on the current aphia id.
     * @protected
     */
    _updateAphiaLink() {
        const id = this.getAphiaId();
        if (id > 0) {
            this._aphiaLink
                .find('a')
                .attr('href', `https://www.marinespecies.org/aphia.php?p=taxdetails&id=${id}`);
            this._aphiaLink.show();
        }
        else {
            this._aphiaLink.hide();
        }
    }
    /**
     * Set species group list
     * @param {SpeciesGroupEntry[]} groups
     */
    setSpeciesGroupList(groups) {
        this._selectSpeciesGroup.clearValues();
        for (const group of groups) {
            this._selectSpeciesGroup.addValue({
                key: `${group.id}`,
                value: group.name
            });
        }
    }
    /**
     * Set the species group
     * @param {number} speciesGroupId
     */
    setSpeciesGroup(speciesGroupId) {
        this._selectSpeciesGroup.setSelectedValue(`${speciesGroupId}`);
    }
    /**
     * Return the species group
     * @returns {number}
     */
    getSpeciesGroup() {
        return parseInt(this._selectSpeciesGroup.getSelectedValue(), 10) || 0;
    }
    /**
     * resetValues
     */
    resetValues() {
        this.setSpecieId(null);
        this.setName('');
        this.setOttId(0);
        this.setAphiaId(0);
        this.setSpeciesGroup(0);
    }
}
